import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Chapter } from '../models/chapter';
import { createChapterEndpoint } from './const';

export const createChapter = (chapter: Chapter) => {
    return getHttpClient().post({ url: createChapterEndpoint, data: JSON.stringify(chapter) });
};
